import styled from "styled-components";

export const SummaryBucketsRowStyled = styled.div`
  display: flex;
  gap: 16px;
  padding: 16px 24px;
`;

export const SummaryBucketCardStyled = styled.div`
  flex: 1;
  padding: 12px 16px;
  border: 1px solid ${(p) => p.theme?.colors?.border ?? "#D8DAE5"};
  border-radius: 10px;
  text-align: center;

  .count {
    font-size: 24px;
    font-weight: 800;
  }
  .label {
    font-size: 11px;
    color: ${(p) => p.theme?.colors?.textSecondary ?? "#5A6A7A"};
    text-transform: uppercase;
    letter-spacing: 0.03em;
  }
`;

export const RolePanelStyled = styled.div`
  padding: 12px 20px;
  background: ${(p) => p.theme?.colors?.light ?? "#F7F7F7"};

  .nested-title {
    font-size: 12.5px;
    font-weight: 700;
    margin-bottom: 8px;
  }
`;
